import React, { useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import { submitSiteDelete } from "../../utils/commonComponent/delete";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import ListView from "../../utils/commonComponent/Custom/listView";
import ListSearchSection from "../../utils/commonComponent/Custom/ListSearchSection";
import { fetchQuery } from "../../utils/commonComponent/fetched";

const headers = ["id", "keyName", "value"];

const fields = [
  { value: "keyName", label: "keyName" },
  { value: "value", label: "Description" },
];

const SettingList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleEdit = (row) => navigate(`/master/editSetting/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("settings", row.id);

  const [settingList, setSettingList] = React.useState([]);
  const [totalRows, setTotalRows] = React.useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "keyName");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
   // Pagination
  const [currentPage, setCurrentPage] = React.useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = React.useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
  };

  // 🔹 WHERE clause builder
  const getWhereClause = () => {
    const colMap = {
      keyName: "keyName",
      value: "value",
    };

    const colName = colMap[searchBy];
    const key = searchKey?.trim().toLowerCase();

    let whereConditions = ["status = 1"]; // always active settings

    if (colName && key) {
      whereConditions.push(`LOWER(${colName}) LIKE '%${key}%'`);
    }

    return whereConditions.length
      ? `WHERE ${whereConditions.join(" AND ")}`
      : "";
  };

  // 🔹 DATA query with pagination
  const getDataQuery = () => {
    const whereClause = getWhereClause();

    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)
        }`;
    }

    return ` SELECT * FROM settings ${whereClause} ORDER BY id DESC ${paginationSettings};`;
  };

  // 🔹 COUNT query
  const getCountQuery = () => {
    const whereClause = getWhereClause();

    return `SELECT COUNT(*) AS totalRows FROM settings ${whereClause};`;
  };

  // 🔹 Fetch data
  const fetchData = async () => {
    try {
      const [unitData, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);

      setSettingList(unitData);
      setTotalRows(countResult?.[0]?.totalRows || 0); // 👈 pagination total
    } catch (error) {
      console.error("Error fetching setting data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("keyName");
    setSearchKey("");
     // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);
  return (
    <>
      <AddButton
        id="btn-add-outline"
        to="/master/editSetting/0"
        label="Add Setting"
        icon={<AddIcon fontSize="small" />}
      />

      <ListSearchSection
        title="Search Remark"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      <ListView
        headers={headers}
        data={settingList}
        actions={{
          edit: handleEdit,
          delete: handleDelete,
        }}
        showCheckbox={true}
        deleteTableName={"settings"}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
      />
    </>
  );
};

export default SettingList;
